import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";

interface FetchBroadwayAvailabilityParams {
  productId?: number;
  month?: string;
}

export const fetchBroadwayAvailability = async ({
  productId,
  month,
}: FetchBroadwayAvailabilityParams): Promise<
  BroadwayAvailabilityResponseDTO[]
> => {
  if (!productId || !month) {
    return [];
  }
  console.log("fetchBroadwayAvailability", productId, month);
  const { data } = await axiosInstance.get<
    ApiResponse<BroadwayAvailabilityResponseDTO[]>
  >("/external-product/broadway/availability", {
    params: { productId, month },
  });
  return data.result;
};

export const useBroadwayAvailability = (
  params: FetchBroadwayAvailabilityParams,
) => {
  return useQuery({
    queryKey: ["broadwayAvailability", params.month, params.productId],
    queryFn: () => fetchBroadwayAvailability(params),
    enabled: !!params.month && !!params.productId,
  });
};
